import auctionImage from '../assets/images/category-auctions.png';
import concertImage from '../assets/images/category-concert.png';
import marketingImage from '../assets/images/category-marketing.png';
import advertsImage from '../assets/images/category-adverts.png';
import podcastsImage from '../assets/images/category-podcasts.png';
import partiesImage from '../assets/images/category-parties.png';
import educationImage from '../assets/images/category-education.png';
import liveCommerceImage from '../assets/images/category-live-commerce.png';
import charityDonationsImage from '../assets/images/category-charity-donations.png';
import comedyShowsImage from '../assets/images/category-comedy-shows.png';

const categories = [
  {
    id: 1,
    name: 'concert',
    imageUrl: concertImage,
  },
  {
    id: 2,
    name: 'auctions',
    imageUrl: auctionImage,
  },
  {
    id: 3,
    name: 'marketing',
    imageUrl: marketingImage,
  },
  {
    id: 4,
    name: 'podcasts',
    imageUrl: podcastsImage,
  },
  {
    id: 5,
    name: 'parties',
    imageUrl: partiesImage,
  },
  {
    id: 6,
    name: 'charity donations',
    imageUrl: charityDonationsImage,
  },
  {
    id: 7,
    name: 'adverts',
    imageUrl: advertsImage,
  },
  {
    id: 8,
    name: 'live commerce',
    imageUrl: liveCommerceImage,
  },
  {
    id: 9,
    name: 'comedy shows',
    imageUrl: comedyShowsImage,
  },
  {
    id: 10,
    name: 'education',
    imageUrl: educationImage,
  },
];

export default categories;
